<template>
    <b-row>
        <b-col cols="12">
            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.completar_datos') }}</h2>
            <div class="subtitle h3 light mb-3 mb-lg-5">
                {{ $t('partido.completa_info_invitaciones') }}.
            </div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.name"
                            id="name"
                            rules="required" 
                            :disabled="desactivar"
                            :label="$t('formularios.nombre')"
                            :name="$t('formularios.nombre')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.apellidos"
                            id="apellidos"
                            rules="required" 
                            :disabled="desactivar"
                            :label="$t('formularios.apellidos')"
                            :name="$t('formularios.apellidos')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <ValidationProvider name="tipo de documento" rules="required" v-slot="{ errors }">
                            <div class="form-group">
                                <label>{{ $t('formularios.tipo_identificacion') }}</label>
                                <multiselect
                                    v-model="localDatosAbonado.tipoDocumentoSeleccionado"
                                    label="type"
                                    track-by="type"
                                    class="custom-multiselect"
                                    :class="(errors[0] ? 'is-invalid' : '')"
                                    id="tipo-documento-comprador"
                                    :placeholder="$t('formularios.tipo_identificacion')"
                                    :options="tiposDocumento"
                                />
                                <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                    {{ errors[0] }}
                                </span>
                            </div>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.dni"
                            id="dni"
                            :rules="evento?.lfp ? { required: true, identificacion: { tipo: localDatosAbonado.tipoDocumentoSeleccionado?.type } } : { required: true }"
                            :disabled="desactivar"
                            :label="$t('formularios.dni')"
                            :name="$t('formularios.dni')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.email"
                            id="email"
                            vid="confirmation"
                            rules="required|email"
                            :disabled="desactivar"
                            :label="$t('formularios.email')"
                            :name="$t('formularios.email')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.email_confirmation"
                            id="email_confirmation"
                            :rules="'required|confirmed_ci:@confirmation'"
                            :disabled="desactivar"
                            :label="$t('formularios.confirmar_email')"
                            :name="$t('formularios.confirmar_email')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.edad"
                            id="edad"
                            rules="required" 
                            :disabled="desactivar"
                            :label="$t('formularios.edad')"
                            :name="$t('formularios.edad')"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <div class="form-group">
                            <label>{{ $t('formularios.telefono') }}</label>
                            <PhoneInput 
                                id="telefono-comprador"
                                :phone="localDatosAbonado.telefono ?? null"
                                :desactivar="desactivar"
                                :required="false"
                                @setNumber="(number) => localDatosAbonado.telefono = number"
                                @validNumber="(valid) => isValidNumber = valid"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <FormInput
                            v-model="localDatosAbonado.cp"
                            id="cp"
                            rules="required" 
                            :disabled="desactivar"
                            :label="$t('formularios.cp')"
                            :name="$t('formularios.cp')"
                        />
                    </b-col>
                    <template v-if="evento?.fields?.length > 0">
                        <div v-for="(field, index) in evento.fields" :key="index" :class="'col-12' + (field.type !== 'textarea' ? ' col-lg-6' : '')">
                            <FieldComponent 
                                :field="field" 
                                :desactivar="desactivar" 
                                v-model="localDatosAbonado.properties[field.name]"
                            />
                        </div>
                    </template>
                    <b-col cols="12" class="mt-3" v-if="evento?.solicitar_datos">
                        <b-row v-for="(asiento, index) in asientosFormateados" :key="index">
                            <b-col cols="12" class="subtitle h3 light mb-3 mb-lg-3 mt-lg-2 mt-4">
                                {{ $t('partido.invitacion') }} Nº {{ index + 1 }}
                            </b-col>
                            <b-col cols="12" lg="4">
                                <FormInput :disabled="desactivar" :label="$t('formularios.nombre')" :name="$t('formularios.nombre') + ' del asiento ' + index++" rules="required" v-model="asiento.nombre" />
                            </b-col>
                            <b-col cols="12" lg="4">
                                <FormInput :disabled="desactivar" :label="$t('formularios.apellidos')" :name="$t('formularios.apellidos') + ' del asiento ' + index++" rules="required" v-model="asiento.apellidos" />
                            </b-col>
                            <b-col cols="12" lg="4" v-if="teatro.hash != '14wAm2L1Jxx5B3J3xBkH'">
                                <label>{{ $t('formularios.telefono') }}</label>
                                <PhoneInput
                                    :id="'asiento-telefono-' + index"
                                    :phone="asiento.telefono ?? null"
                                    :desactivar="desactivar"
                                    :required="true"
                                    :error_telefono="true"
                                    @setNumber="(number) => asiento.telefono = number"
                                    @validNumber="(valid) => asiento.isValidNumberEntrada = valid"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12">
                        <button
                            id="compra-responsive"
                            :class="['button', 'large-button','mr-2','my-2', { 'effect-button': !desactivar }]"
                            type="submit"
                            :disabled="desactivar"
                        >
                            <span>{{ $t('partido.continuar') }}</span>
                        </button>

                        <span
                            role="button"
                            id="atras"
                            :class="['button', 'large-button', 'ml-lg-3', 'compra-responsive', { 'effect-button': !desactivar }]"
                            @click="$emit('borrarSesionAndCambiarPaso')"
                        >
                            <span>{{ $t('formularios.atras') }}</span>
                        </span>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
    import PhoneInput from '@/components/common/PhoneInput.vue';

    export default {
        props: {
            evento: {
                type: Object,
                required: true
            },
            sesion_id: {
                type: String,
                required: true
            },
            session_id: {
                type: String,
                required: true
            },
            abonado: {
                type: Object,
                required: true
            },
            asientos: {
                type: Array,
                required: true
            },
            zona: {
                type: Object,
                required: true
            },
            desactivar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localDatosAbonado: { ...this.abonado },
                isValidNumber: false,
                isValidNumberEntrada: false,
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" }
                ]
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid && this.isValidNumber && this.asientosFormateados.every(asiento => asiento.isValidNumberEntrada)) {
                    const payload = {
                        filters: {},
                        abonado_id: this.abonado.id,
                        evento_id: this.evento.id,
                        sesion_id: this.sesion_id,
                        session_id: this.session_id,
                        datos_compradores: {
                            email: this.localDatosAbonado.email,
                            nombre: this.localDatosAbonado.name,
                            apellidos: this.localDatosAbonado.apellidos,
                            telefono: this.localDatosAbonado.telefono,
                            dni: this.localDatosAbonado.dni,
                            asientos: this.asientosFormateados.map(a => ({
                                asiento: {
                                    fila: a.asiento.fila,
                                    asiento: a.asiento.asiento,
                                    zona_id: a.asiento.zona_id
                                },
                                nombre: a.nombre,
                                apellidos: a.apellidos,
                                dni: a.dni,
                                telefono: a.telefono
                            }))
                        }
                    };
                    this.$emit('guardarDatos', payload, this.localDatosAbonado);
                } else {
                    this.$nextTick(function() {
                        this.$scrollTo('.is-invalid', 100)
                    });
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            asientosFormateados() {
                return this.asientos.map(asiento => {
                    const base = asiento.asiento ? asiento.asiento : asiento;

                    return {
                        asiento: {
                            fila: base.fila,
                            asiento: base.asiento,
                            zona_id: base.zona_id
                        },
                        nombre: asiento.nombre || this.localDatosAbonado.name || '',
                        apellidos: asiento.apellidos || this.localDatosAbonado.apellidos || '',
                        dni: asiento.dni || this.localDatosAbonado.dni || '',
                        telefono: asiento.telefono || this.localDatosAbonado.telefono || '',
                        isValidNumberEntrada: asiento.isValidNumberEntrada || false
                    };
                });
            }
        },
        components: {
            PhoneInput
        }
    }
</script>